import React, {  useState  } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(theme => ({
    inputContainer: {
        padding: '12px',
        position: 'relative',
        width: '100%',
    },
    searchInput: {
        border: '1px solid rgba(0,0,0,.15)',
        borderRadius: theme.borderRadius.min,
        color: '#4c4c4c',
        fontSize: '14px',
        height: '32px',
        lineHeight: '22px',
        margin: '0',
        outline: 0,
        padding: '5px 22px 5px 8px',
        width: '100%',
        appearance: 'none',
        '&::placeholder': {
            fontSize: '14px',
            color: 'rgba(0,0,0,.15)',
        },
        '&:focus': {
            borderColor:theme.colors.mainGreen6,
          }
    },
    searchIcon: {
        color: theme.colors.disableColor,
        position: 'absolute',
        right: '16px',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'inline-block',
        fontStyle: 'normal',
        lineHeight: '0',
        textAlign: 'center',
        marginRight: '8px',
       
    },


}))

const InputSearch = ({
    onChange, placeholder, value
}) => {
    const [defaultValue,setDefaultValue]=useState(value?value:"");
    const classes = useStyles();
    const { inputContainer, searchInput, searchIcon } = classes;
    const inputChangeEvent =(e)=>{
        onChange?.(e?.target?.value);
        setDefaultValue(e?.target?.value);
    }
    return (
        <div className={inputContainer}>
            <input
                onChange={inputChangeEvent}
                placeholder={placeholder}
                className={searchInput}
                value={defaultValue}
            />
            <SearchOutlined className={searchIcon} />
        </div>)
}

InputSearch.propTypes = {
    onChange: PropTypes.func,
    placeholder: PropTypes.string, 
    value: PropTypes.string,
}

export default InputSearch;